import { Component, Inject, Input } from '@angular/core';
import { Offer } from '@innogy/become-a-customer/shared/interfaces';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  JssModule,
  type ComponentFields,
} from '@sitecore-jss/sitecore-jss-angular';
import { ENVIRONMENT_CONFIG } from '@core/config-angular';
import { EnvironmentConfig } from '@core/config-models';
import { CommonModule } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { ToolTipComponent } from '@legacy/common-ui-utility-components';
import { CSCaptureDirective } from '@legacy/utils-contentsquare';
import {
  GenericRichTextDirective,
  TextInterpolationPipe,
} from '@core/jss-utils';
import { RoundedCurrencyPipe } from '@innogy/utils-deprecated';

import { getMGMSharedValue } from '../../helpers/member-get-member';
import { getYearlyCostsFields, getYearlyCostsLabel } from '../../helpers';

@Component({
  selector: 'wl-offer-budgetbill[rendering]',
  templateUrl: './offer-budgetbill.component.html',
  styleUrls: [
    './offer-budgetbill.component.ed.scss',
    './offer-budgetbill.component.essent.scss',
  ],
  standalone: true,
  imports: [
    CommonModule,
    ToolTipComponent,
    AutomationIdDirective,
    CSCaptureDirective,
    GenericRichTextDirective,
    TextInterpolationPipe,
    RoundedCurrencyPipe,
    JssModule,
  ],
})
export class OfferBudgetbillComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public rendering!: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public offer?: Offer;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() public hasMemberGetMember = false;

  get fields(): ComponentFields | any {
    return this.rendering.fields;
  }

  displayMGM(hasMGM: boolean): boolean {
    return hasMGM && !!this.mgmSharedValue;
  }

  get mgmSharedValue() {
    return getMGMSharedValue(this.offer, this.environmentConfig.brand);
  }

  get yearlyCostLabel() {
    return getYearlyCostsLabel(
      ...getYearlyCostsFields(this.rendering),
      this.offer
    );
  }

  constructor(
    @Inject(ENVIRONMENT_CONFIG)
    private readonly environmentConfig: EnvironmentConfig
  ) {}
}
